<ng-container *ngIf="isVisible">

  <!-- ── Overlay ──────────────────────────────────────────────────────────── -->
  <div
    class="popup-overlay"
    [class.popup-overlay--out]="isAnimatingOut"
  ></div>

  <!-- ── Wrapper centré ───────────────────────────────────────────────────── -->
  <div
    class="popup-wrapper"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="title"
  >
    <div [ngClass]="popupClasses">

      <!-- ── Header ─────────────────────────────────────────────────────── -->
      <div [ngClass]="headerClasses">

        <!-- Icône gauche du titre -->
        <span *ngIf="addIconLeft" class="popup__header-icon popup__header-icon--left">
          <ng-content select="[slot='header-icon-left']"></ng-content>
        </span>

        <!-- Titre -->
        <h2 class="popup__title">{{ title }}</h2>

        <!-- Icône droite du titre (entre le titre et le ✕) -->
        <span *ngIf="addIconRight" class="popup__header-icon popup__header-icon--right">
          <ng-content select="[slot='header-icon-right']"></ng-content>
        </span>

        <!-- Bouton fermeture -->
        <button
          class="popup__close"
          type="button"
          aria-label="Fermer"
          (click)="close()"
        >
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 2L16 16M16 2L2 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>

      </div>

      <!-- ── Body ───────────────────────────────────────────────────────── -->
      <div class="popup__body">
        <ng-content></ng-content>
      </div>

      <!-- ── Footer ─────────────────────────────────────────────────────── -->
      <div class="popup__footer">
        <ng-content select="[slot='footer']"></ng-content>
      </div>

    </div>
  </div>

</ng-container>